import React, {useCallback} from 'react';
import styled from "styled-components";
import RankingDropBox from "../../../../common/RankingDropBox";
import ChampSearchWrapper from "./ChampSearchWrapper";
import {GET_CHAMPIONS_BY_SEASON_REQUEST} from "../../../../../store/reducer/summoner";
import {useDispatch, useSelector} from "react-redux";
import {useParams} from "react-router-dom";


const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 10px;
`;

const SeasonWrapper = styled.div`
  height: 28px;
`;

const ResetButton = styled.button`
  margin-left: 10px;
  width: 40px;
  height: 40px;
  background: ${props => props.theme.color.site_main_color} url(${props => props.theme.icon.path + '/ico_reset.svg'}) no-repeat center;
  border: 1px solid ${props => props.theme.color.default_border_color};
  border-radius: 6px;
  font-size: 0;
  text-indent: -9999px;

  &:hover {
    background-color: ${props => props.theme.color.white_200};
  }

`;

const TableARAMFilter = ({season, seasonList, onChangeSelectedSeason, selectedSeason, onChangeInput, handleReset}) => {
    const dispatch = useDispatch();
    const summoner = useSelector((state) => state.summoner.summoner);
    const {region} = useParams();
    const onChangeSeason = useCallback((e) => {
        const value = e.target.value;
        if (value && summoner) {
            onChangeSelectedSeason(value);
            dispatch({
                type: GET_CHAMPIONS_BY_SEASON_REQUEST,
                data: {
                    platform_id: region,
                    puu_id: summoner.summoner_basic_info_dict.puu_id,
                    season: value,
                }
            });
        }

    }, [summoner]);


    return (
        <Wrapper>
            <SeasonWrapper>
                <RankingDropBox
                    onChange={onChangeSeason}
                    selected={(data) => Number(data) === Number(selectedSeason)}
                    value={(data) => seasonList.find((item) => data === item.value)?.value}
                    title={(data) => seasonList.find((item) => data === item.value)?.title}
                    list={[...season,23]}
                />
            </SeasonWrapper>

            <ChampSearchWrapper
                onChangeInput={onChangeInput}
            >
            </ChampSearchWrapper>
        </Wrapper>
    );
};

export default TableARAMFilter;




